import Vue from "vue";
import App from "./App.vue";
import Adal from "vue-adal";

import * as microsoftTeams from "@microsoft/teams-js";
import { IConfiguration } from "@interfaces/local";
import { localApi } from "@api/local-api";
import { configuration, isInWebMode } from "@tools/configuration";
import { getBearerToken } from "./tools/session";
import { ajaxCall } from "./tools/axios-wrapper";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import vSelect from "vue-select";
import VCalendar from "v-calendar";

import "./style/bootstrap-custom.scss";
import { IDictionary } from "./interfaces/shared";

import { declarationApi, declarationRPApi } from "./wapi/declaration-api";
import referentialApi from "./wapi/referential-api";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

// Use v-calendar & v-date-picker components
// https://vcalendar.io/installation.html#_2a-plugin-method-recommended
Vue.use(VCalendar, {
  // https://vcalendar.io/api/v2.0/defaults.html
});
Vue.component("v-select", vSelect);

Vue.directive("click-outside", {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event: any) {
      const ignoreClass = Object.keys(binding.modifiers);
      // Ignore items with a certain class
      const path = event.composedPath && event.composedPath();
      const containsIgnoredClass =
        path && ignoreClass.some((c) => path.some((p: HTMLElement) => p.classList && p.classList.contains(c)));
      if (
        !containsIgnoredClass &&
        !(el === event.target || el.contains(event.target)) &&
        vnode.context &&
        (!path || path.indexOf(el) === -1) &&
        binding.expression
      ) {
        (vnode.context as unknown as IDictionary<any>)[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function (el) {
    if (el.clickOutsideEvent) {
      document.body.removeEventListener("click", el.clickOutsideEvent);
    }
  }
});

Vue.config.productionTip = false;
localApi.getLocalConfiguration().then(async (config: IConfiguration) => {
  if (config) {
    await Promise.all([declarationApi.init(), referentialApi.init(), declarationRPApi.init()]);

    Object.assign(configuration, config);

    const store = (await import("./store")).store;
    const router = (await import("./router")).default;

    ajaxCall.initAjaxStore({
      interceptor: async (config) => {
        const bearer = await getBearerToken();
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${bearer}`
        };
        return config;
      }
    });

    console.log("isInWebMode : ", isInWebMode());
    if (isInWebMode() === true) {
      // config static
      Object.assign(configuration, {
        cacheLocation: "localStorage",
        navigateToLoginRequestUrl: false
      });

      Vue.use(Adal, {
        config: configuration,
        requireAuthOnInitialize: true,
        router
      });

      new Vue({
        router,
        store,
        render: (h) => h(App)
      }).$mount("#app");
    } else {
      // prod/staging through teams only
      microsoftTeams.initialize(() => {
        new Vue({
          router,
          store,
          render: (h) => h(App)
        }).$mount("#app");
      });
    }
  }
});

declare global {
  // eslint-disable-next-line
  interface HTMLElement {
    clickOutsideEvent?: (event: any) => void;
  }
}
